import { DateTime } from "luxon";

/**
 * Quando relativo, em português, para trilhos e atalhos de data.
 * Sempre no fuso da operação (America/Fortaleza no produto).
 */

export function formatRelativeWhen(
  date: Date,
  timezone: string,
  isAllDay = false,
): { day: string; time: string } {
  const zone = DateTime.fromJSDate(date, { zone: timezone }).setLocale("pt-BR");
  const today = DateTime.now().setZone(timezone).startOf("day");
  const target = zone.startOf("day");
  const diff = Math.round(target.diff(today, "days").days);

  let day: string;
  if (diff === 0) day = "Hoje";
  else if (diff === 1) day = "Amanhã";
  else if (diff === -1) day = "Ontem";
  else if (diff > 1 && diff < 7) day = zone.toFormat("cccc");
  else day = zone.toFormat("ccc, dd LLL");

  const time = isAllDay ? "Dia inteiro" : zone.toFormat("HH:mm");
  return { day, time };
}

export function nextWeekdayDate(timezone: string, weekday: number, from?: DateTime): DateTime {
  const today = (from ?? DateTime.now().setZone(timezone)).startOf("day");
  const delta = (weekday - today.weekday + 7) % 7;
  return today.plus({ days: delta === 0 ? 7 : delta });
}
